module.exports = __webpack_public_path__ + "images/present.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/present.png
 ** module id = 53
 ** module chunks = 1
 **/